interface EndPoint {
  url?: string;
  list?: string;
  add?: string;
  edit?: string;
  delete?: string;
  service?: string;
}

export const end_points: Record<string, EndPoint> = {
  get_chart_options: {
    url: "/analytics/written_content_total_views",
    service: "ms1",
  },
  global_settings: {
    url: "/settings/global-settings",
    service: "ms1",
  },
  get_profile_engagement_chart_options: {
    url: "/v1/user/profile-engagement-metrics-monthly",
    service: "ms1",
  },
  list_announcement: {
    url: "/announcement/list",
    service: "ms1",
  },
  tags_suggest_list: {
    url: "/tags/suggest-list",
    service: "",
  },
  tags_list: {
    url: "/user/tags/list",
    service: "",
  },
  super_admin_tags_suggest_list: {
    url: "/tag/suggest-tags-list",
    service: "",
  },
  list_announcements: {
    url: "/announcement/popup-list",
    service: "ms1",
  },
  add_announcement: {
    url: "/announcement/create",
    service: "ms1",
  },
  update_announcement: {
    url: "/announcement/update", //:id
  },
  status_announcement: {
    url: "/announcement/updateStatus", //:id
  },
  delete_announcement: {
    url: "/announcement/delete", //:id
  },
  authLoginApi: {
    url: "/auth/new-login",
    service: "ms1",
  },
  authRegisterApi: {
    url: "/auth/new-register",
    service: "ms1",
  },
  verifyOtpApi: {
    url: "/auth/verify-otp",
    service: "ms1",
  },
  sendClaimOtpApi: {
    url: "/auth/send-claim-otp",
    service: "ms1",
  },
  verifyClaimOtpApi: {
    url: "/auth/verify-claim-otp",
    service: "ms1",
  },
  claimedUserDetails: {
    url: "/about/claimed-user",
    service: "ms1",
  },
  claimVerification: {
    url: "/about/claim-verification",
    service: "ms1",
  },
  claimVerificationApprovedEmail: {
    url: "/user/claim-verification-approved-email",
    service: "ms1",
  },
  userByNpi: {
    url: "/about/user-by-npi",
    service: "ms1",
  },
  contactUsProvider: {
    url: "/about/contactusprovider",
    service: "ms1",
  },
  claimReport: {
    url: "/about/claim-report",
    service: "ms1",
  },
  claimedAccount: {
    url: "/auth/claimed-account",
    service: "ms1",
  },
  aboutCheckEmail: {
    url: "/about/check-email",
    service: "ms1",
  },
  generateEmail: {
    url: "/auth/generate-mail",
    service: "ms1",
  },
  verifyEmail: {
    url: "/auth/verify-mail",
    service: "ms1",
  },
  verifyEmailStatus: {
    url: "/about/verified-email",
    service: "ms1",
  },
  contact_us: {
    url: "/contactus/create",
    service: "ms1",
  },
  resendOtpApi: {
    // url: "/auth/resend-otp",
    url: "auth/resend-login-otp", //:authkey
    service: "ms1",
  },
  // /api/auth/confirm-login/:authkey
  authConfirm_Login_Api: {
    url: "auth/confirm-login",
    service: "ms1",
  },
  // --- Sales Rep module (temporary, Phase 1 + 2) — isolated here so real
  // URLs can be swapped in one place. ---
  salesRepAuthLoginApi: {
    url: "/super-admin/temp-user/rep-login",
    service: "ms1",
  },
  // GET, query param master_type=provider_type — despite the param name this
  // returns the Primary Speciality category list (id + category_name).
  salesRepPrimarySpecialities: {
    url: "/master/feature-category-type/list",
    service: "ms1",
  },
  // POST { category_id }. Provider Type is dependent on the chosen Primary
  // Speciality — call this whenever that selection changes.
  salesRepProviderRolesByCategory: {
    url: "/master/temp_user/provider-roles/by-category",
    service: "ms1",
  },
  // GET, query params page/limit — server-side paginated, returns totalCount.
  salesRepProviderList: {
    url: "/super-admin/temp-user/list",
    service: "ms1",
  },
  salesRepAddProvider: {
    url: "/super-admin/temp-user/create",
    service: "ms1",
  },
  salesRepDeleteProvider: {
    url: "/super-admin/temp-user/delete",
    service: "ms1",
  },
  authMe: {
    url: "auth/me",
    service: "ms1",
  },
  authUpdateSubscriptionApi: {
    url: "auth/update-subscription",
    service: "ms1",
  },
  forgot_password_mail: {
    url: "/auth/forgot-password-mail",
    service: "ms1",
  },
  decrypt_user_details: {
    url: "/auth/decrypt-user-detail",
    service: "ms1",
  },
  password_reset_mail: {
    url: "/auth/forgot-password",
    service: "ms1",
  },
  userprofile_education: {
    url: "/about/education/create",
    service: "ms1",
  },
  userprofile_education_update: {
    url: "/about/education/update",
    service: "ms1",
  },
  userprofile_board_cirtification: {
    url: "about/broad-certificate/create",
    service: "ms1",
  },
  userprofile_board_cirtification_update: {
    url: "about/broad-certificate/update",
    service: "ms1",
  },
  user_about_list: {
    url: "about/lists",
    service: "ms1",
  },
  settings_professional_insurance: {
    url: "/about/professional-insurance/update",
    service: "ms1",
  },
  settings_license: {
    url: "/about/license",
    service: "ms1",
  },
  settings_parental_control: {
    url: "/about/parental-settings",
    service: "ms1",
  },
  settings_parental_control_listing: {
    url: "/about/parental-settings/list",
    service: "ms1",
  },
  profile_image_upload: {
    url: "/about/upload-profile-image",
    service: "ms1",
  },

  userprofile_fellowships: {
    url: "about/fellow-ships/create",
    service: "ms1",
  },
  userprofile_fellowships_update: {
    url: "about/fellow-ships/update",
    service: "ms1",
  },
  userprofile_residency: {
    url: "about/residency/create",
    service: "ms1",
  },
  userprofile_residency_update: {
    url: "about/residency/update",
    service: "ms1",
  },
  userprofile_internship: {
    url: "about/internship/create",
    service: "ms1",
  },
  userprofile_internship_update: {
    url: "about/internship/update",
    service: "ms1",
  },
  userprofile_finance_create: {
    url: "about/finance/create",
    service: "ms1",
  },
  userprofile_communities: {
    url: "about/communities-served",
    service: "ms1",
  },
  userprofile_sharedexperience: {
    url: "about/shared-experience/list",
    service: "ms1",
  },
  userprofile_sharedexperience_update: {
    url: "about/update-shared-experience",
    service: "ms1",
  },
  getAvailablePackagesApi: {
    url: "/stripe/product",
    service: "ms1",
  },
  profile_about_email: {
    url: "about/email",
    service: "ms1",
  },
  profile_about_phone: {
    url: "/about/phone",
    service: "ms1",
  },
  profile_about_availablity: {
    url: "/about/availability/create",
    service: "ms1",
  },
  profile_about_clinical: {
    url: "/about/update-clinical-specialities",
    service: "ms1",
  },
  profile_about_treatment_update: {
    url: "/about/treatment-modality/update",
    service: "ms1",
  },
  profile_about_addlink_create: {
    url: "/about/create-url",
    service: "ms1",
  },
  profile_about_addlink_update: {
    url: "/about/update-url",
    service: "ms1",
  },
  profile_about_addidentity_update: {
    url: "/about/my-identity/update",
    service: "ms1",
  },
  get_primary_credentials: {
    url: "/about/primary-credentials",
    service: "ms1",
  },
  profile_gallery_images_upload: {
    url: "/about/upload-gallery-image",
    service: "ms1",
  },
  profile_gallery_images_lists: {
    url: "/about/gallery/lists",
    service: "ms1",
  },
  profile_gallery_images_delete: {
    url: "/about/delete/gallery-image",
    service: "ms1",
  },
  profile_about_location: {
    url: "/about/location/create",
    service: "ms1",
  },
  profile_gallery_image_update: {
    url: "/about/gallery/update",
    service: "ms1",
  },

  countriesListApi: {
    url: "/master/countrieslist",
    service: "ms1",
  },
  masterHealthRoleApi: {
    url: "/master/mentalhealth-role/list",
    service: "ms1",
  },
  masterClinicalRoleApi: {
    url: "/master/clinical-role/list",
    service: "ms1",
  },
  createRegisterApi: {
    url: "auth/new-register",
    service: "ms1",
  },
  quickLoginRegisterApi: {
    url: "auth/quick-login-register",
    service: "ms1",
  },
  profile_about_personal_info: {
    url: "/about/basic-information",
    service: "ms1",
  },
  mater_designation_list: {
    url: "/master/designation/list",
    service: "ms1",
  },
  authEmailCheckApi: {
    url: "/auth/email-check",
    service: "ms1",
  },
  master_clinical_specialties: {
    url: "/master/clinical-specialties/list",
    service: "ms1",
  },
  master_clinical_expertise: {
    url: "/master/clinical-expertise/list",
    service: "ms1",
  },
  master_clinical_experience: {
    url: "/master/clinical-experience/list",
    service: "ms1",
  },
  master_treatment_modality: {
    url: "/master/treatment-modality/list",
    service: "ms1",
  },
  master_treatment_expertise: {
    url: "/master/treatment-expertise/list",
    service: "ms1",
  },
  master_treatment_experience: {
    url: "/master/treatment-experience/list",
    service: "ms1",
  },
  master_category: {
    url: "/master/role-category/list",
    service: "ms1",
  },
  master_subCategory: {
    url: "master/role-category/list", //:id
    service: "ms1",
  },
  master_group: {
    url: "/master/group/list",
    service: "ms1",
  },
  master_insurance_methods: {
    url: "master/finance-insurance/list",
    service: "ms1",
  },
  treatmentModalityListApi: {
    url: "about/treatment-modality/list",
    service: "ms1",
  },
  getSpecialitiesListApi: {
    url: "about/clinical-specialities/list",
    service: "ms1",
  },
  uploadVideoBunny: {
    url: "v1/videos/create-video",
    service: "ms1",
  },
  UpdateVideo: {
    url: "v1/videos/update",
    service: "ms1",
  },
  createVideo: {
    url: "v1/videos/create",
    service: "ms1",
  },
  startTranscription: {
    url: "transcription/start",
    service: "ms1",
  },
  transcriptionStatus: {
    url: "transcription/status",
    service: "ms1",
  },
  transcriptionStatusBulk: {
    url: "transcription/status-bulk",
    service: "ms1",
  },
  retryTranscription: {
    url: "transcription/retry",
    service: "ms1",
  },
  listAddedVideos: {
    url: "/videos/lists",
    service: "ms1",
  },
  deleteAddedVideos: {
    url: "videos/delete", //:id
    service: "ms1",
  },
  statusUpdateVideos: {
    url: "videos/updateStatus", //:id
    service: "ms1",
  },
  master_myIdentity_getfaith: {
    url: "master/faith/list",
    service: "ms1",
  },
  master_myIdentity_getrace: {
    url: "master/races/list",
    service: "ms1",
  },
  master_getLanguages: {
    url: "/master/language/list",
    service: "ms1",
  },
  master_getAges: {
    url: "/master/ages/list",
    service: "ms1",
  },
  add_events: {
    url: "/event/create",
    service: "ms1",
  },
  update_events: {
    url: "/event/update", //:id
    service: "ms1",
  },
  list_events: {
    url: "/event/list",
    service: "ms1",
  },
  view_profile_list_events: {
    url: "event/provider/list",
    service: "ms1",
  },
  announcement_popupListApi: {
    url: "/announcement/popup-list",
    service: "ms1",
  },
  suggestedVideosAndBlogsApi: {
    url: "common/suggested/video-blog",
    service: "ms1",
  },
  recommendedProviderList: {
    url: "common/client-provider/list",
    service: "ms1",
  },
  master_certification_listApi: {
    url: "master/certification/list",
    service: "ms1",
  },
  master_ethenticity_listApi: {
    url: "/master/ethnicity/list",
    service: "ms1",
  },

  master_providerRoleListApi: {
    url: "master/provider-role/list",
    service: "ms1",
  },
  settings_license_image_upload: {
    url: "about/upload-license-document",
    service: "ms1",
  },

  settings_license_images_delete: {
    url: "about/delete-license-document",
    service: "ms1",
  },
  settings_account_email_update: {
    url: "about/personal-information",
    service: "ms1",
  },
  settings_account_password_update: {
    url: "about/user-change-password",
    service: "ms1",
  },
  settings_account_deactivate: {
    url: "about/deactivate-account",
    service: "ms1",
  },
  settings_subscription_list: {
    url: "/stripe/product/subscription",
    service: "ms1",
  },
  master_particpant_listApi: {
    url: "master/participant/list",
    service: "ms1",
  },
  licenseCheckApi: {
    url: "auth/license-check",
    service: "ms1",
  },
  master_provider_catgeory_listApi: {
    url: "master/provider-category",
    service: "ms1",
  },
  feture_provider_list: {
    url: "v1/about/providers",
    service: "ms1",
  },
  feture_provider_list_by_slug: {
    url: "v1/about/providers-by-slugs",
    service: "ms1",
  },
  user_provider_search_filter: {
    url: "user/provider/list/dropdown",
    service: "ms1",
  },
  get_user_top_providers: {
    url: "user/top-providers",
    service: "ms1",
  },
  get_user_top_reviewed: {
    url: "user/top-providers-review",
    service: "ms1",
  },
  get_top_videos: {
    url: "common/top/video/lists",
    service: "ms1",
  },
  get_trending_videos: {
    url: "common/trending/video/lists",
    service: "ms1",
  },
  get_latest_videos: {
    url: "common/latest/video/lists",
    service: "ms1",
  },
  get_all_category_videos: {
    url: "common/video-content/category/lists",
    service: "ms1",
  },
  category_videos_list: {
    url: "videos/list-all-videos",
    service: "ms1",
  },
  live_stream_videos_list: {
    url: "videos/live-streams",
    service: "ms1",
  },
  list_feed: {
    url: "about/list-feed",
    service: "ms1",
  },
  providers_online_list: {
    url: "provider/online/list",
    service: "ms1",
  },
  master_category_list: {
    url: "master/category/list",
    service: "ms1",
  },

  writtenContent_Create_Api: {
    url: "written-content/create",
    service: "ms1",
  },
  writtenContent_Update_Api: {
    url: "written-content/update", // /:id
    service: "ms1",
  },
  writtenContent_Lists_Api: {
    url: "written-content/lists",
    service: "ms1",
  },
  writtenContent_Delete_Api: {
    url: "written-content/delete", // /:id
    service: "ms1",
  },
  // written-content/update-status
  writtenContent_StatusUpdate_Api: {
    url: "written-content/update-status", // /:id
    service: "ms1",
  },
  master_keywWordsSuggestionsApi: {
    url: "master/categories-subcategories",
    service: "ms1",
  },
  writtenContent_delete_Api: {
    url: "written-content/delete", // /:id
    service: "ms1",
  },
  writtenContent_UpdateStatus_Api: {
    url: "written-content/update-current-status", // /:id
    service: "ms1",
  },
  writtenContent_Articles_list: {
    url: "written-content/articles-list",
    service: "ms1",
  },
  master_providers_list: {
    url: "master/provider/list",
    service: "ms1",
  },
  master_conditions_list: {
    url: "master/condition/list",
    service: "ms1",
  },
  master_indendedAudience_list: {
    url: "master/indended-audience/list",
    service: "ms1",
  },
  master_theraphy_list: {
    url: "master/therapy/list",
    service: "ms1",
  },
  total_rating_list: {
    url: "about/star-rate",
    service: "ms1",
  },
  homepage_provider_list: {
    url: "about/providers-list",
    service: "ms1",
  },
  master_provider_for_create: {
    url: "master/provider/create",
    service: "ms1",
  },
  master_conditions_create: {
    url: "master/condition/create",
    service: "ms1",
  },
  master_indended_audience_create: {
    url: "master/indended-audience/create",
    service: "ms1",
  },
  master_theraphy_create: {
    url: "master/therapy/create",
    service: "ms1",
  },
  profile_about_tags_for_filter: {
    url: "about/tags-for-filter",
    service: "ms1",
  },
  home_featured_providers_list: {
    url: "about/featured-providers",
    service: "ms1",
  },
  about_link_delete: {
    url: "about/delete-url",
    service: "ms1",
  },
  about_link_update: {
    url: "about/update-url",
    service: "s1",
  },
  about_other_clinical: {
    url: "about/update-other-clinical-specialities",
    service: "ms1",
  },
  about_other_treatment: {
    url: "about/other-treatment-modality/update",
    service: "ms1",
  },
  about_status_update: {
    url: "user/provider/update-status",
    service: "ms1",
  },
  settings_subscription_plan_update_Api: {
    url: "subscription/change-plan-new",
    service: "ms1",
  },
  confirmSubscriptionPlanApi: {
    url: "subscription/confirm-change-plan",
    service: "ms1",
  },
  currentSubscriptionPlanListApi: {
    url: "auth/current-plan-list",
    service: "ms1",
  },
  add_to_favourites: {
    url: "videos/update-favourite",
    service: "ms1",
  },
  get_upcoming_events: {
    url: "event/upcoming-events",
    service: "ms1",
  },
  get_upcoming_client: {
    url: "event/upcoming-event-client",
    service: "ms1",
  },
  get_review_details: {
    url: "review/client-reviews/statistics",
    service: "ms1",
  },
  get_review_list: {
    url: "review/list",
    service: "ms1",
  },
  review_delete: {
    url: "review/delete",
    service: "ms1",
  },
  //
  about_review_send_mail: {
    url: "review/create",
    service: "ms1",
  },
  about_review_list: {
    url: "review/get-rating-list",
    service: "ms1",
  },
  about_review_total_stats: {
    url: "review/client-reviews/statistics",
    service: "ms1",
  },
  about_generate_link: {
    url: "review/generate-link",
    service: "ms1",
  },
  about_review_email_log: {
    url: "review/list",
    service: "ms1",
  },
  billing_WalletAddCardApi: {
    url: "wallet/add-card",
    service: "ms1",
  },
  billing_walletGetCardDetailApi: {
    url: "wallet/get-card-detail",
    service: "ms1",
  },
  review_submit: {
    url: "/v1/review/fill",
    service: "ms1",
  },
  getTransactionListApi: {
    url: "wallet/get-transaction-list",
    service: "ms1",
  },
  getTransactionHistoryDownloadApi: {
    url: "wallet/transaction-history-download",
    service: "ms1",
  },
  getTransactionHistoryInvoicePdf: {
    url: "wallet/transaction-invoice",
    service: "ms1",
  },

  updateWalletBillingAddress: {
    url: "wallet/billing-address",
    service: "ms1",
  },
  walletDefaultPaymentMethodApi: {
    url: "wallet/default-payment-method",
    service: "ms1",
  },
  get_client_review_list: {
    url: "review/lists/client-reviews",
    service: "ms1",
  },
  master_get_flag_reasons: {
    url: "master/review-flag/list",
    service: "ms1",
  },
  reviews_make_featured: {
    url: "review/make-featured",
    service: "ms1",
  },
  review_reminder: {
    url: "review/reminder",
    service: "ms1",
  },
  review_send_reply: {
    url: "review/reply",
    service: "ms1",
  },
  download_review_excel: {
    url: "review/client-reviews/export/excel",
    service: "ms1",
  },
  download_review_csv: {
    url: "review/client-reviews/export/csv",
    service: "ms1",
  },
  review_flag_update: {
    url: "review/flag-raise",
    service: "ms1",
  },
  get_recommendedBlogs_list: {
    url: "written-content/recommended/articles/lists",
    service: "ms1",
  },
  get_singleArticle_Details: {
    url: "written-content/list",
    service: "ms1",
  },
  add_deposit_wallet_api: {
    url: "wallet/wallet-deposit",
    service: "ms1",
  },
  settings_send_otp: {
    url: "auth/get-twilio-otp",
    service: "ms1",
  },
  settings_verify_email: {
    url: "auth/verify-twilio-otp",
    service: "ms1",
  },
  get_related_vidoes: {
    url: "videos/related-videos",
    service: "ms1",
  },
  settings_deactivate_account: {
    url: "auth/deactivate-two-factor",
    service: "ms1",
  },

  clientSecret_depositApi: {
    url: "wallet/get-client-secret-deposit",
    service: "ms1",
  },
  wallet_AddAmountApi: {
    url: "wallet/add-amount",
    service: "ms1",
  },
  wallet_withdraw_Api: {
    url: "wallet/wallet-withdraw",
    service: "ms1",
  },
  // Go Live
  go_live_now: {
    url: "/v1/videos/create-live-stream",
    service: "ms1",
  },
  world_wide_stream: {
    url: "stream/create-live-stream",
    service: "ms1",
  },
  live_stream_link: {
    url: "/stream/call/link",
    service: "ms1",
  },
  live_stream_start: {
    url: "/stream/live-start",
    service: "ms1",
  },
  go_schedule_live_now: {
    url: "/stream/create-schedule-stream",
    service: "ms1",
  },
  go_schedule_live_update: {
    url: "/stream/update-schedule-stream",
    service: "ms1",
  },
  go_live_chat_list: {
    url: "/stream/stream-chat-list",
    service: "ms1",
  },
  go_live_private_chat_list: {
    url: "/stream/chat/users-search",
    service: "ms1",
  },
  go_live_client_private_chat_list: {
    url: "/stream/chat/users-search-list",
    service: "ms1",
  },
  go_live_client_private_chat_new_list: {
    url: "/stream/chat/user-list",
    service: "ms1",
  },
  worldwide_feed_cancel: {
    url: "/stream/world-wide-feed-cancel",
    service: "ms1",
  },
  get_worldwide_feed: {
    url: "/stream/home/live-video",
    service: "ms1",
  },
  get_home_worldwide_feed: {
    url: "/stream/home/live-video-world-wide",
    service: "ms1",
  },
  get_worldwide_playlist_current: {
    url: "/stream/world-wide-playlist/current",
    service: "ms1",
  },
  get_live_user_details: {
    url: "/stream/get-provider-details",
    service: "ms1",
  },
  get_upcoming_live_events: {
    url: "/stream/upcoming-live-list",
    service: "ms1",
  },
  decrypt_data: {
    url: "/auth/channel_decrypt_crypto",
    service: "ms1",
  },
  encrypt_data: {
    url: "/auth/channel_encrypt_crypto",
    service: "ms1",
  },
  send_stream_joined_info: {
    url: "/stream/client/stream-join",
    service: "ms1",
  },
  join_golive: {
    url: "/v1/videos/join-golive",
    service: "ms1",
  },
  peek_invite: {
    url: "/v1/videos/peek-invite",
    service: "ms1",
  },
  subscription_PreviewPlan_Api: {
    url: "subscription/preview-plan-new",
    service: "ms1",
  },
  viewprofile_review_list: {
    url: "review/list/client-review-details",
    service: "ms1",
  },
  viewprofile_email_us: {
    url: "user/email-us",
    service: "ms1",
  },
  settings_verification_doc_upload: {
    url: "about/verify_document",
    service: "ms1",
  },
  provider_review_statistics: {
    url: "review/client-reviews-details/statistics",
    service: "ms1",
  },
  get_topBlogs_list: {
    url: "written-content/articles-list",
    service: "ms1",
  },
  written_content_views_count_update_Api: {
    url: "written-content/views/count/update",
    service: "ms1",
  },
  wallet_confirm_add_card_Api: {
    url: "wallet/confirm-add-card",
    service: "ms1",
  },
  send_email_token: {
    url: "review/connect",
    service: "ms1",
  },
  authSubscriptionConfirmPlanApi: {
    url: "subscription/confirm-plan",
    service: "ms1",
  },
  authSubscriptionPlanApi: {
    url: "subscription/subscribe-plan",
    service: "ms1",
  },
  authSubscriptionRenewalConfirmApi: {
    url: "subscription/renewal-confirm",
    service: "ms1",
  },
  subscription_upgradeFreePlanConfirmApi: {
    url: "subscription/upgradefreeplan-confirm",
    service: "ms1",
  },
  subscription_upgradeClaimPlanConfirmApi: {
    url: "subscription/upgradeclaimplan-confirm",
    service: "ms1",
  },
  client_annoucement_list: {
    url: "announcement/providers-list",
    service: "ms1",
  },
  category_suggestion_list: {
    url: "about/home-feed",
    service: "ms1",
  },
  common_search_suggestion_list: {
    url: "common/search",
    service: "ms1",
  },
  followAndUnFollow_Api: {
    url: "about/follow-provider",
    service: "ms1",
  },
  getFollowStatus_Api: {
    url: "about/follow-status",
    service: "ms1",
  },
  getProviderSubscriptionPlanListApi: {
    url: "user/provider-subscription-plan/lists", // /:providerid
    service: "ms1",
  },
  // user/subscribe-provider/:providerid
  updateSubscriptionPlanApi: {
    url: "user/subscribe-provider",
    service: "ms1",
  },
  search_tag_list_api: {
    url: "/search/list",
    service: "ms1",
  },
  get_subscribers_listApi: {
    url: "user/subscribed-followed-providers",
    service: "ms1",
  },
  client_category_list_api: {
    url: "user/home-feed-details-list",
    service: "ms1",
  },
  client_recommended_list: {
    url: "common/recommended-topics/list",
    service: "ms1",
  },
  client_follow_count_api: {
    url: "metrics/subscribed-followed-providers-count",
    service: "ms1",
  },
  total_main_page_views: {
    url: "metrics/total-main-page-views",
    service: "ms1",
  },
  total_phone_inquiries: {
    url: "metrics/total-phone-inquiries",
    service: "ms1",
  },
  total_forms_filled: {
    url: "metrics/total-directory-form",
    service: "ms1",
  },
  content_views_chart: {
    url: "metrics/content-views-chart",
    service: "ms1",
  },
  save_tune_your_home: {
    url: "user/home-feed-details/update",
    service: "ms1",
  },
  list_tune_your_home: {
    url: "user/home-feed-details-list",
    service: "ms1",
  },
  client_account_settings_update: {
    url: "user/account-settings/client/profile/update",
    service: "ms1",
  },
  // stream/live-video-list
  liveStreamVideoList_Api: {
    url: "stream/live-video-list",
    service: "ms1",
  },
  search_suggestion: {
    url: "search/suggest",
    service: "ms1",
  },
  videos_share_update: {
    url: "videos/update-share",
    service: "ms1",
  },
  getLiveVideoList_Api_with_language: {
    url: "stream/live-video-list-language",
    service: "ms1",
  },
  video_like: {
    url: "videos/update-like-data",
    service: "ms1",
  },
  providers_online_live: {
    url: "user/currently/live",
    service: "ms1",
  },
  client_subscribed_providers: {
    url: "user/subscribed-providers",
    service: "ms1",
  },
  client_subscribed_summary: {
    url: "metrics/subscription-summary-metrics",
    service: "ms1",
  },
  client_subscription_pause: {
    url: "user/pause-provider-subscription",
    service: "ms1",
  },
  client_subscription_resume: {
    url: "user/resume-provider-subscription",
    service: "ms1",
  },
  client_subscription_cancel: {
    url: "user/update-subscription-status",
    service: "ms1",
  },
  get_client_favourite_video_lists_api: {
    url: "videos/favourite-lists",
    service: "ms1",
  },
  client_wellness_catgeory_list: {
    url: "user/wellness-hub-data/list",
    service: "ms1",
  },
  deleteWalletCardApi: {
    url: "wallet/delete-card",
  },
  call_leads_update: {
    url: "user/call-leads-update",
    service: "ms1",
  },
  client_wellness_recommended_videos_list: {
    url: "videos/wellness-hub/recommended/videos/list",
  },
  client_hub_list_wellness_hub: {
    url: "/master/get-all-feature-categories-with-cms",
  },
  get_followers_list_api: {
    url: "metrics/total-followers-count",
    service: "ms1",
  },
  get_provider_page_view_api: {
    url: "metrics/total-subscribers-count",
    service: "ms1",
  },
  get_subscription_revenue_api: {
    url: "metrics/total-subscription-revenue",
    service: "ms1",
  },
  get_main_page_views_api: {
    url: "metrics/total-main-page-views",
    service: "ms1",
  },
  get_special_events_api: {
    url: "metrics/total-special-event-revenue",
    service: "ms1",
  },
  get_non_subscriber_api: {
    url: "metrics/total-non-subscriber-views",
    service: "ms1",
  },
  get_combined_event_api: {
    url: "metrics/total-combined-event-revenue",
    service: "ms1",
  },
  get_special_event_revenue_api: {
    url: "metrics/total-live-metrics",
    service: "ms1",
  },
  provider_video_performance_list: {
    url: "metrics/bunny-metrics/history",
    service: "ms1",
  },
  provider_video_performance_favourites_list: {
    url: "metrics/top-favourite-videos",
    service: "ms1",
  },
  provider_video_performance_profile_views: {
    url: "analytics/profile-graph",
    service: "ms1",
  },
  provider_video_performance_engaement_metrics: {
    url: "analytics/video-engage-metrics",
    service: "ms1",
  },
  provider_video_performance_getSubscribe_count: {
    url: "analytics/get-subscriber-graph",
    service: "ms1",
  },
  provider_video_performace_total_minutes: {
    url: "analytics/total-live-stream",
    service: "ms1",
  },
  provoider_video_performance_revenue_generated: {
    url: "analytics/provider/revenue",
    service: "ms1",
  },
  onetime_payment_create: {
    url: "stream/pay-per-live-video",
    service: "ms1",
  },
  provider_written_content_overview: {
    url: "analytics/written_content_metrics",
    service: "ms1",
  },
  provider_written_content_profile_view: {
    url: "analytics/written_content_traffic_source",
    service: "ms1",
  },
  provider_written_content_engagement_metrix: {
    url: "analytics/written_content_engage_metrics",
    service: "ms1",
  },
  provider_written_content_top_ten_performer: {
    url: "written-performance/topFavoritecontents",
    service: "ms1",
  },
  provider_financial_metrics: {
    url: "earning/finance-metrics",
    service: "ms1",
  },
  provider_financial_Overview: {
    url: "analytics/revenue-overview",
    service: "ms1",
  },
  provider_overall_financial_Overview: {
    url: "earning/finance-margins",
    service: "ms1",
  },
  provider_subscriber_financial: {
    url: "earning/finance-subscribed-Unsubscribed",
    service: "ms1",
  },
  provider_profile_performance: {
    url: "user/call-leads/list",
    service: "ms1",
  },
  client_ticket_create: {
    url: "support-ticket/create",
    service: "ms1",
  },
  client_ticket_list: {
    url: "support-ticket/list",
    service: "ms1",
  },
  client_ticket_details: {
    url: "support-ticket/lists",
    service: "ms1",
  },
  popularVideosCategory_Api: {
    // url: "videos/provider-category",
    url: "v1/about/popular-videos",
    service: "ms1",
  },
  client_ticket_update: {
    url: "support-ticket/update",
    service: "ms1",
  },
  client_ticket_delete: {
    url: "support-ticket/delete",
    service: "ms1",
  },
  // auth/sso-login/:user_role
  ssoLogin_Api: {
    url: "auth/sso-login",
    service: "ms1",
  },
  // calendar/client-upcoming-events
  calendar_UpcomingEvents_Api: {
    url: "v1/event/calendar-event/list",
    // url: "calendar/client-upcoming-events",
  },
  // auth/new-register/popup
  registerPopupModel_Api: {
    url: "auth/new-register/popup",
  },
  video_share_generate_key: {
    url: "videos/generate-unique-id",
    service: "ms1",
  },
  video_update_share_count: {
    url: "videos/update-share-data",
    service: "ms1",
  },
  written_content_share_count: {
    url: "written-content/views/count/update",
    service: "ms1",
  },
  written_content_generate_unique: {
    url: "written-content/generate-article-shareid",
    service: "ms1",
  },
  written_content_fav_update: {
    url: "written-content/favourite/count",
    service: "ms1",
  },
  written_content_like_update: {
    url: "written-content/like/count",
    service: "ms1",
  },
  get_category_details: {
    url: "common/wellness-hub",
    service: "ms1",
  },
  update_profile_view_count: {
    url: "user/profile/view/count",
    service: "ms1",
  },
  get_category_local_recommmendations: {
    url: "/v1/user/wellness-hub-data-list/local-recommendation/lists",
    service: "ms1",
  },
  get_sub_category_details: {
    url: "/common/wellness-hub",
    service: "ms1",
  },
  get_client_notification_list: {
    url: "/common/notification/list",
    service: "ms1",
  },
  live_stream_video_duration: {
    url: "/videos/add-video-history",
    service: "ms1",
  },
  get_client_upcomingevent_list: {
    url: "v1/event/upcoming-events-client",
    service: "ms1",
  },
  delete_notification: {
    url: "/common/notification/delete",
    service: "ms1",
  },
  client_upcoming_events_list: {
    url: "v1/event/get-upcoming-events-client",
    service: "ms1",
  },
  update_event_count: {
    url: "event/view/count",
    service: "ms1",
  },
  get_schedulepast_stream_list: {
    url: "v1/videos/schedule-stream-history",
    service: "ms1",
  },
  schedule_stream_remind: {
    url: "videos/schedule-reminder",
    service: "ms1",
  },
  schedule_stream_cancel: {
    url: "videos/schedule-cancel",
    service: "ms1",
  },
  get_top_liked_videos: {
    url: "videos/top-videos-list",
    service: "ms1",
  },
  get_events: {
    url: "event/explore-upcoming-events",
    service: "ms1",
  },
  get_ticket_id: {
    url: "support-ticket/get-ticketid",
    service: "ms1",
  },
  add_events_to_calendar: {
    url: "event/calendar-event/create",
    service: "ms1",
  },
  recommended_view_count: {
    url: "user/recommented/view/count",
    service: "ms1",
  },
  leads_message_sent: {
    url: "user/lead/message",
    service: "ms1",
  },
  leads_delete: {
    url: "user/leadcall/delete",
    service: "ms1",
  },
  notification_read_unread: {
    url: "common/notification/update-status",
    service: "ms1",
  },
  mark_all_as_read: {
    url: "common/notification-view-all",
    service: "ms1",
  },
  get_notification_status: {
    url: "user/get-prefrenece-donotdisturb-status",
    service: "ms1",
  },
  donot_disturb: {
    url: "user/do-not-disturb-mode",
    service: "ms1",
  },
  preference_changes: {
    url: "user/preference-setting",
    service: "ms1",
  },
  ww_stream_set_data: {
    url: "slots/create-slot",
    service: "ms1",
  },
  // ww_get_slots_data: {
  //   url: "slots/list",
  //   service: "ms1",
  // },
  ww_get_slots_data_utc: {
    url: "slots/available-slots/list",
    service: "ms1",
  },
  ww_stream_get_table_data: {
    url: "stream/world-wide-feed/list",
    service: "ms1",
  },
  tax_form_get_details: {
    url: "about/tax-form-detail",
    service: "ms1",
  },
  tax_form_update: {
    url: "about/tax-form-update",
    service: "ms1",
  },
  earnings_overview: {
    url: "earning/metrics",
    service: "ms1",
  },
  earnings_export: {
    url: "earning/metrics-export",
    service: "ms1",
  },
  earnings_revenue_analytics_: {
    url: "earning/Income-Expense",
    service: "ms1",
  },
  set_ww_slot_expiry: {
    url: "/slots/add-slot",
    service: "ms1",
  },
  event_most_popular: {
    url: "event/upcoming-most-popular",
    service: "ms1",
  },
  events_trending: {
    url: "event/upcoming-trending",
    service: "ms1",
  },
  events_recommended: {
    url: "event/upcoming-recommend",
    service: "ms1",
  },
  events_newest: {
    url: "event/upcoming-newest",
    service: "ms1",
  },
  todays_events: {
    url: "event/upcoming-today-event",
    service: "ms1",
  },
  upcoming_events_list: {
    url: "event/upcoming-event-provider",
    service: "ms1",
  },
  start_record: {
    url: "/agora/start",
    service: "ms1",
  },
  stop_record: {
    url: "/agora/stop",
    service: "ms1",
  },
  stop_record_new: {
    url: "/stream/update-stream-live-status",
    service: "ms1",
  },
  get_latest_article: {
    url: "written-content/latest-feature/list",
    service: "ms1",
  },
  get_notification_setting: {
    url: "user/get-allow-push-notification",
    service: "ms1",
  },
  update_notification_setting: {
    url: "user/allow-push-notifications",
    service: "ms1",
  },
  client_recommended_topics: {
    url: "common/recommended-topics-data/list",
    service: "ms1",
  },
  my_subscriptions_followers: {
    url: "common/wellness-hub-subscribe/subscribe-followers/lists",
  },
  email_subcription: {
    url: "subscription/email-subscibtion",
    service: "ms1",
  },
  logout_api: {
    url: "auth/logout-status",
    service: "ms1",
  },
  provider_my_subscribers_list: {
    url: "user/subscribed-clients",
    service: "ms1",
  },
  wallet_delete_card: {
    url: "wallet/delete-card",
    service: "ms1",
  },
  get_slug_status: {
    url: "/slug/create-slug",
    service: "ms1",
  },
  get_award: {
    url: "/award/get-awards",
    service: "ms1",
  },
  get_wellness_hub_common: {
    url: "common/wellness-hub-list",
    service: "ms1",
  },
  get_wellness_local_recommendations_common: {
    url: "/v1/local-recommendations",
    service: "ms1",
  },
  get_ratingList_slug: {
    url: "review/get-rating-list-data",
    service: "ms1",
  },
  get_relatedVideos_slug: {
    url: "videos/related-videos-data",
    service: "ms1",
  },
  get_providerDetail_slug: {
    url: "about/lists-data",
    service: "ms1",
  },
  follow_status_slug: {
    url: "about/follow-status-data",
    service: "ms1",
  },
  promocode_metrics: {
    url: "super-admin/promo-code/metrics",
    service: "ms1",
  },
  referrer_promo_codes: {
    url: "auth/referrer-promo-codes",
    service: "ms1",
  },
  promocode_apply: {
    url: "super-admin/promo-code/apply-promo-code",
    service: "ms1",
  },
  commission_list: {
    url: "user/get-commission-list-data",
    service: "ms1",
  },
  provider_follow_status: {
    url: "about/follow-status",
    service: "ms1",
  },
  new_basic_information_update: {
    url: "about/basic-information-provider",
    service: "ms1",
  },
  new_updated_personal_statement: {
    url: "about/update-personal-statement",
    service: "ms1",
  },
  client_ticket_reply: {
    url: "support-ticket/reply-client",
    service: "ms1",
  },
  new_contact_info_update: {
    url: "about/profile/edit",
    service: "ms1",
  },
  get_master_sub_group: {
    url: "master/get-subgroup",
    service: "ms1",
  },
  get_header_menu_list: {
    url: "about/parent-menu",
    service: "ms1",
  },
  get_header_navigation_list: {
    url: "cms/navigation/list",
  },
  get_Menu_Details: {
    url: "about/menu-pages",
    service: "ms1",
  },
  get_master_details: {
    url: "about/master-pages",
    service: "ms1",
  },
  provider_written_content_list: {
    url: "written-content/submitted-lists",
    service: "ms1",
  },
  my_written_content: {
    url: "written-content/my-content",
    service: "ms1",
  },
  asset_list: {
    url: "common/asset/list",
    service: "ms1",
  },

  asset_list_image: {
    url: "common/pre-defined/list",
    service: "ms1",
  },

  predefined_page_list: {
    url: "super-admin/predefined-page/lists",
    service: "ms1",
  },
  get_section_list: {
    url: "super-admin/home-section/lists",
  },
  cms_list: {
    url: "auth/cms-page-list",
  },
  cms_list_slug: {
    url: "cms-pages/list",
  },
  favorite_content: {
    url: "written-content/get-favourite-content",
  },
  add_favorite_content: {
    url: "written-content/favourite/count",
  },

  transaction_list: {
    url: "v1/wallet/transaction-history/list",
  },
  add_card: {
    url: "wallet/add-card",
  },
  wallet_wallet_deposit: {
    url: "/wallet/wallet-deposit",
  },
  cancel_subscription_list: {
    url: "/v1/user/get-cancelled-subscriptions",
  },
  re_active_subscription: {
    url: "/v1/user/reactivate-subscription-plan",
  },
  deactivate_account: {
    url: "/about/deactivate-account",
  },
  payment_invoice_email: {
    url: "v1/wallet/alternative-invoice-email/update",
  },
  get_language_list: {
    url: "/master/language/list",
  },

  content_access: {
    url: "user/update-content-access",
  },
  get_content_access: {
    url: "user/get-content-access",
  },
  client_wallet_withdraw_Api: {
    url: "v1/wallet/wallet-withdraw",
  },
  add_locality: {
    url: "master/add-locality",
  },

  update_calendar_status: {
    url: "/v1/event/update-calender-status",
  },
  client_home_feed_list: {
    url: "v1/home-feed/list",
  },
  provider_near_me: {
    url: "/v1/about/provider-near",
  },
  find_provider: {
    url: "v1/user/get-same-providers",
  },
  content_may_like: {
    url: "v1/written-content/content-may-like",
  },
  related_videos: {
    url: "v1/videos/getrelatedvideoWellness",
  },
  get_profile: {
    url: "v1/about/get-profile",
  },
  unfollowed_user: {
    url: "v1/user/unfollowedUser",
  },
  hide_post: {
    url: "v1/home-feed/hide-post",
  },
  follow_provider: {
    url: "about/follow-provider",
  },
  favourite_count: {
    url: "v1/announcement/favourite/count",
  },
  get_popular_topic_feed: {
    url: "v1/videos/get-popular-topics",
  },
  get_related_videos: {
    url: "v1/user/get-relatedvideo-providers",
  },
  get_network_provider: {
    url: "v1/user/get-same-providers",
  },
  get_profile_upcoming_events: {
    url: "v1/event/upcoming-events-feeds",
  },
  get_category_list_data: {
    url: "/v1/user/wellness-hub",
  },
  get_category_list_without_login: {
    url: "/v1/user/wellness-hub-list",
  },
  add_announcement_favorite: {
    url: "/v1/announcement/favourite/count",
  },
  add_live_event_favorite: {
    url: "videos/update-favourite",
  },
  live_share_generate_key: {
    url: "/videos/generate-unique-id",
  },
  get_live_link: {
    url: "/v1/user/get-user-live-link",
  },
  add_exclusive_price: {
    url: "v1/videos/add-exclusive-video-price-request",
  },
  set_content_access: {
    url: "user/set-content-access",
  },
  get_recommented_events: {
    url: "/v1/event/get-recommeded-events",
  },
  promocode_apply_stream: {
    url: "/slots/validate-promo",
  },
  review_send_mail: {
    url: "v1/review/create",
    service: "ms1",
  },
  review_copy_link: {
    url: "/review/generate-link ",
  },
  get_order_details: {
    url: "/videos/get-video-data-with-wallet-balance",
  },
  checkout_order: {
    url: "/stream/pay-per-live-video",
  },
  my_events: {
    url: "/v1/event/get-my-events",
  },
  cancel_event: {
    url: "/event/cancel-event",
  },
  reschedule_event: {
    url: "/event/reschedule",
  },
  provider_revision_request_list: {
    url: "/v1/written-content/revision-requested-content",
  },
  get_video_add_list: {
    url: "/videos/avaliable-video/list",
  },
  create_video_row: {
    url: "videos/add-manage-video-entry",
  },
  get_manage_video_list: {
    url: "/videos/manage-video-list",
  },
  delete_video: {
    url: "videos/delete-manage-video",
  },
  delete_manage_video: {
    url: "/videos/delete",
  },
  change_video_status: {
    url: "videos/updateStatus",
  },
  update_video_row_title: {
    url: "videos/update-video-data",
  },
  delete_video_row: {
    url: "videos/manage-video",
  },
  move_video_section: {
    url: "videos/update-video-data-list/",
  },
  get_profile_link: {
    url: "/v1/about/get-profile-link",
  },
  tax_form_save: {
    url: "/about/tax-form-update",
  },
  tax_form_list: {
    url: "/about/tax-form-detail",
  },

  get_provider_data: {
    url: "v1/review/get-provider-details",
  },
  downgrade_subscriptionplan: {
    url: "/subscription/downgrade-free-plan",
  },
  is_provider: {
    url: "/about/check-if-provider",
  },
  add_to_network: {
    url: "about/add-remove-provider-on-network",
  },
  network_and_follow_provider: {
    url: "about/network-and-follow-provider",
  },
  get_provider_list: {
    url: "about/get-my-network-providers",
  },
  monetization_list: {
    url: "v1/adv/monetization/list",
  },
  get_monetization: {
    url: "v1/adv/monetization/list/user",
  },
  get_monetization_by_id: {
    url: "v1/adv/monetization",
  },
  create_monetization: {
    url: "v1/adv/monetization/create",
  },
  update_monetization: {
    url: "v1/adv/monetization/update",
  },
  delete_monetization: {
    url: "v1/adv/monetization",
  },
  monetization_revenue_stats: {
    url: "v1/adv/monetization/revenue-stats",
  },
  update_monetization_status: {
    url: "v1/adv/monetization/update-status",
  },
  get_network_feed_list: {
    url: "about/get-all-feeds/my-network-providers",
  },
  get_provider_type_list: {
    url: "/master/provider-role/list",
  },
  provider_my_subscriptions: {
    url: "/subscription/unsubscribe-plan",
  },
  provider_cancel_subscription_list: {
    url: "/subscription/unsubscribed-plans-list",
  },
  my_account_blocked_list: {
    url: "/v1/user/blocked-list",
  },
  my_account_unblocked_list: {
    url: "/v1/user/unblock",
  },
  my_account_subscribed_list: {
    url: "/user/subscribed-clients",
  },
  profile_performance_overview: {
    url: "/v1/user/profile-performance-overview",
    service: "ms1",
  },
  profile_completion: {
    url: "/v1/user/get-profile-completion",
  },
  get_recent_profile_updated: {
    url: "/v1/user/get-recent-profile-updates",
  },
  get_profile_engagement_metrics: {
    url: "/v1/user/profile-engagement-metrics",
  },
  get_profile_get_genderdemography: {
    url: "/v1/user/get-gender-demography",
  },
  get_audience_demographics_age: {
    url: "/about/audience-demographics-age",
  },
  my_account_get_accept_status: {
    url: "/v1/user/subscriber-status",
  },
  my_account_update_accept_status: {
    url: "/v1/user/update-subscriber-status",
  },
  my_account_block_user: {
    url: "/v1/user/block",
  },
  my_account_video_count: {
    url: "/v1/videos/subscription-video-count",
  },
  provider_click_count: {
    url: "/user/click/profile/count",
    service: "ms1",
  },
  my_profile_follower_views_performance: {
    url: "/v1/user/my-profile-follower-views-performance-data",
    service: "ms1",
  },
  get_toplocation_based_profileview: {
    url: "/v1/user/get-top-location-based-profile-view",
  },
  get_followers_view_percentage: {
    url: "/v1/user/my-profile-follower-views-performance-percentage",
  },
  add_location_profile_count: {
    url: "/v1/user/add-location-based-profile-view",
  },
  get_analytics_financial_performance: {
    url: "/v1/analytics/financial-performance",
  },
  get_revenue_overview_list: {
    url: "/v1/analytics/revenue-overview",
  },
  get_finacial_metrics: {
    url: "/v1/analytics/financial-metrics",
  },
  export_financial_metrics: {
    url: "/v1/analytics/financial-metrics/export",
  },
  get_financial_transaction_history: {
    url: "/v1/analytics/transaction-history",
  },
  get_suggested_edit: {
    url: "v1/written-content",
  },
  update_revision_request: {
    url: "written-content/revision-request",
  },
  get_follow_and_followers: {
    url: "about/get-followers-and-following-data",
  },
  fetch_lead_track_data: {
    url: "/v1/user/get-lead-status-list",
  },
  lead_track_status_update: {
    url: "/v1/user/add-lead-status",
  },
  get_lead_status_update: {
    url: "/user/call-leads-status-update",
  },
  freePlanSignup: {
    url: "/auth/new-register-free-plan",
  },
  upgradeAccount: {
    url: "subscription/upgrade-free-to-paid-plan",
  },
  settings_subscription_plan_downgrade_Api: {
    url: "/subscription/downgrade-free-plan",
  },
  get_written_content_analytics: {
    url: "/written-content/getWritenContentAnalyticsData",
  },
  create_live_stream: {
    url: "/v1/videos/create-live-stream",
  },
  update_live_stream: {
    url: "v1/videos/update-schedule-stream",
  },
  update_slug: {
    url: "v1/videos/video-slug-update",
  },
  get_provider_type_data: {
    url: "master/provider-type/data",
  },
  announcement_favorite_content: {
    url: "/v1/announcement/get-favourite-annoucment",
  },
  update_annocement: {
    url: "v1/announcement/update-annoucment-views-count",
  },
  get_events_dashboard: {
    url: "/event/upcoming-events-dashboard",
  },
  get_calender_event: {
    url: "/event/calendar-event/list",
  },
  add_to_my_events: {
    url: "/event/calendar-event/create",
  },
  get_provider_role: {
    url: "master/provider-role/list/",
  },
  condition_list: {
    url: "master/condition-list",
  },
  treatment_modality: {
    url: "master/treatment-modality/list",
  },
  search_by_tags: {
    url: "/videos/search-by-tags",
  },
  provider_category_list: {
    url: "master/role-category-hierarchy",
  },
  videos_search: {
    url: "videos/list-all-videos/feeds",
  },
  feature_provider_list: {
    url: "v1/about/featured-providers",
  },
  feature_provider_list_new: {
    url: "v1/about/providers/featured",
  },
  get_location_data: {
    url: "master/get-location-data",
  },
  store_popular_city: {
    url: "v1/about/store-popular-city-searches",
  },
  get_popular_city: {
    url: "v1/about/get-popular-city-searches",
  },
  filter_video_list: {
    url: "v1/about/get-videos-by-keywords",
  },
  upcomming_streams: {
    url: "search/get-upcoming-world-wide",
  },
  clinical_deduct_amount: {
    url: "/about/add-clinical-data-with-deduction",
  },
  notificattion_update_status: {
    url: "/common/notification/update-status",
  },
  getProviderData: {
    url: "/about/split/basic-profile",
  },
  getProffessionalData: {
    url: "/about/split/professional",
  },
  getMyFollowerList: {
    url: "/v1/user/getmyfollower-subs-details",
  },
  user_category_list: {
    url: "about/split/categories",
  },
  subscribe_promocode_apply: {
    url: "/promo-code/apply-promo-code-client",
    service: "ms1",
  },
  get_category_datas: {
    url: "/cms-pages/get-wellness-cms",
  },
  basicProfileApi: {
    url: "/about/get-basic-profile",
  },
  getClinicalDataApi: {
    url: "/about/get-clinical-specialties",
  },
  getTreatmentModalityDataApi: {
    url: "/about/treatment-modality-specialty",
  },
  getCommunitiesServedDataApi: {
    url: "/about/communities-served",
  },
  getFinanceDataApi: {
    url: "/about/finance",
  },
  view_profile_data: {
    url: "/about/view-profile-data",
  },
  getTreatmentModalityDataViewProfileApi: {
    url: "/about/get-treatment-modality-specialty",
  },
  getAwardsDataViewProfileApi: {
    url: "/about/get-awards",
  },
  getFinanceDataViewProfileApi: {
    url: "/about/view-finance",
  },
  getGalleryDataViewProfileApi: {
    url: "/about/view-gallery/lists",
  },
  getCommunitiesServedDataViewProfileApi: {
    url: "/about/get-communities-served",
  },
  getViewClinicalSpecialtiesDataViewProfileApi: {
    url: "/about/get-view-clinical-specialties",
  },
  getPlanViewProfileApi: {
    url: "/about/get-plan-type",
  },
  master_audience_list: {
    url: "/master/audience-based/list",
    service: "ms1",
  },
  master_subtypes_list: {
    url: "/master/subtypes/all",
    service: "ms1",
  },
  new_wellness_hub: {
    url: "common/new-wellness-hub",
    service: "ms1",
  },
  get_follower_following: {
    url: "about/get-followers-based-providers",
  },
  get_unsubscribed_providers_list: {
    url: "subscription/unsubscribed-plans-list",
  },
  blog_update_share_count: {
    url: "/written-content/views/count/update",
    service: "ms1",
  },
  get_all_videos_events: {
    url: "videos/get-all-videos-events",
  },
  get_all_categories_with_cms: {
    url: "/master/get-all-categories-with-cms",
  },
  is_card_exist: {
    url: "wallet/check-card-exists",
  },
  get_all_categories_list: {
    url: "/master/feature-provider-categories/provider_type",
  },
  get_feature_provider_categories: {
    url: "/master/feature-provider-categories",
  },
  get_feature_featured_provider_subcategory: {
    url: "/master/feature-provider-subcategory",
  },
  get_feature_featured_provider_group: {
    url: "/master/feature-provider-group",
  },
  get_feature_featured_provider_subgroup: {
    url: "/master/feature-provider-subgroup",
  },
  get_categories_by_master_type: {
    // url: "/master/categories/by-master-type",
    url: "/master/feature-category-type/list",
    service: "ms1",
  },
  get_subcategories_by_category_ids: {
    url: "/master/sub-categories/by-category-ids",
    service: "ms1",
  },
  /* New */
  get_new_subcategories_by_category_ids: {
    url: "/master/sub-categories-list/by-category-ids",
    service: "ms1",
  },
  get_new_groups_by_category_subcategory: {
    url: "/master/groups-list/by-category-subcategory",
    service: "ms1",
  },
  get_new_subgroups_by_category_subcategory_group: {
    url: "/master/subgroups-list/by-category-subcategory-group",
    service: "ms1",
  },
  /* New */
  get_groups_by_category_subcategory: {
    url: "/master/groups/by-category-subcategory",
    service: "ms1",
  },
  get_subgroups_by_category_subcategory_group: {
    url: "/master/subgroups/by-category-subcategory-group",
    service: "ms1",
  },
  get_billing_plans_list: {
    url: "/v1/adv/billing-plans/list",
  },
  adv_video_list: {
    url: "/videos/lists",
  },
  master_feature_provider_categories_provider_type: {
    url: "master/feature-provider-categories/provider_type",
  },
  master_country_list: {
    url: "master/countries/list",
  },
  master_state_list: {
    url: "master/states/list",
  },
  master_city_list: {
    url: "master/cities/list",
  },
  create_campaign: {
    url: "/v1/adv/campaigns/create",
  },
  campaign_eligibility: {
    url: "/v1/adv/campaigns/eligibility",
  },
  campaigns_list_data: {
    url: "/v1/adv/campaigns/list",
  },
  campaigns_list_export: {
    url: "/v1/adv/campaigns/list/export",
  },
  campaigns_delete: { url: "/v1/adv/campaigns" },
  get_campaign: {
    url: "/v1/adv/campaigns",
  },
  update_campaign: {
    url: "/v1/adv/campaigns/update",
  },
  get_campaign_type: {
    url: "/v1/adv/campaign-settings/list",
  },
  get_target_audience: {
    url: "/v1/adv/targeting-control/list",
  },
  get_feature_provider_category_all_list: {
    url: "/master/provider-type/data",
  },
  get_all_provider_type_list: {
    url: "/master/feature-provider-categories/provider_type",
  },
  get_provider_type_dropdownlist: {
    url: "/master/provider-type/data",
  },
  get_provider_type: {
    url: "master/provider-type/data",
  },
  get_finance_list: {
    url: "master/finance-insurance/list",
  },
  list_wellness_categories: {
    url: "master/get-all-feature-categories",
  },
  user_about_list_api: {
    url: "/about/lists-user-data",
  },
  global_script_list_api: {
    url: "/global-script-settings/list",
  },
  video_unsubscribe_api: {
    url: "user/unsubscribe-provider",
  },
  unsubscribe_api: {
    url: "/subscription/email-unsubscribe",
  },
  master_category_api: {
    url: "master/sub-categories/by-category-ids",
    service: "ms1",
  },
  report_content: {
    url: "/admin-flag/create",
  },
  get_role_based_category: {
    url: "/master/account-type/list",
  },
  get_stripe_keys: {
    url: "/auth/get-stripe-keys",
  },
  get_response_messages: {
    url: "/response-messages",
  },
  npi_check: {
    url: "auth/npi-check",
    service: "ms1",
  },
  get_provider_clasification: {
    url: "master/provider-classifications/by-category-id",
    service: "ms1",
  },
  get_provider_roles_by_category_classification: {
    url: "master/provider-roles/by-category-classification",
    service: "ms1",
  },
  get_primary_credential_settings: {
    url: "auth/primary-credential-settings",
  },
  get_contact: {
    url: "/common/pre-defined/list/contact",
  },
  nonprofit_verification: {
    url: "/about/nonprofit/verification",
  },
  get_donation: {
    url: "/donation/get-my-donors-list",
  },
  create_donation: {
    url: "donation/send-thank-you-email-donor",
  },
  get_alldonation: {
    url: "/v1/user/donation-performance",
  },
  donation_create_payment_intent: {
    url: "/donation/create-donation",
  },
  donation_confirm_donation: {
    url: "/donation/confirm-donation",
  },
  get_donation_history: {
    url: "/user/get-donation-history",
  },
  get_donation_breakdown: {
    url: "/analytics/donations/breakdown",
  },
  get_donation_analytics: {
    url: "/analytics/donations/analytics",
  },
  get_donation_monthly_contributions: {
    url: "/analytics/donations/monthly-contributions",
  },
  get_donation_performance_donar_engage: {
    url: "/v1/analytics/donation-performance/donar-engage",
  },
  get_donation_performance_top_cities: {
    url: "/v1/analytics/donation-performance/top-cities",
  },
  get_donation_performance_top_supporters: {
    url: "/v1/analytics/donation-performance/top-supporters",
  },
  get_donation_performance_anonymous_gift: {
    url: "/v1/analytics/donation-performance/anonymous-gift",
  },
  get_donation_performance_metrics: {
    url: "/analytics/donations/metrics",
  },
  set_update_subscriber_status: {
    url: "/v1/user/update-subscriber-status",
  },
  get_export: {
    url: "/donation/donation-list-export/excel",
  },
  campaign_status_update: {
    url: "/v1/adv/campaigns/update-status",
  },
  master_client_interested_categories: {
    url: "/master/client-interested-categories",
  },
  home_feed_detail_clients: {
    url: "/v1/adv/home-feed-details",
  },
  status_information_update: {
    url: "/user/get-organization-details",
  },
  program_type_list: {
    url: "/master/program_type",
  },
  video_view_count: {
    url: "/videos/view-count-update/:videoId",
  },
  ad_view: {
    url: "/v1/adv/campaigns/ad-view",
  },
  meeting_group_list: {
    url: "/meeting/get-meet-lists",
  },
  // meeting_create: {
  //   url: "/meeting/create",
  // },
  get_meeting_link: {
    url: "/meeting/slug-check/",
  },
  create_self_meeting: {
    url: "/meeting/create",
  },
  meeting_create: {
    url: "/meeting/create",
  },
  meeting_delete: {
    url: "/meeting/cancel-group-meeting",
  },
  meeting_get_by_id: {
    url: "/meeting/get-meet-by-data",
  },
  meeting_chat_enable: {
    url: "/meeting/chat/enable",
  },
  meeting_chat_disable: {
    url: "/meeting/chat/disable",
  },
  meeting_chat_append: {
    url: "/meeting/chat/append",
  },
  meeting_chat_get: {
    url: "/meeting/chat",
  },
  meeting_update_by_meeting_Id: {
    url: "/meeting/update",
  },
  meeting_waiting_room_list: {
    url: "/meeting/waiting-room/getWaitingRoomList",
  },
  meeting_get_waiting_room_by_slug: {
    url: "/meeting/get-waiting-room",
  },
  check_meet_anonymous: {
    url: "/meeting/check-meet-anonymous",
  },
  meeting_get_meeting_settings: {
    url: "/meeting/get-meeting-settings",
  },
  update_meeting_settings: {
    url: "/meeting/update-meeting-settings",
  },
  get_meeting_settings: {
    url: "/meeting/get-meeting-settings",
  },
  get_moderator_attendes_list: {
    url: "/v1/about/get-users-details",
  },
  check_meet_passcode: {
    url: "/meeting/check-meet-passcode",
  },
  handle_cancel_meeting_self: {
    url: "/meeting/cancel-meeting-by-index-or-series",
  },
  meeting_waiting_room_status: {
    url: "/meeting/waiting-room-status",
  },
  meeting_waiting_room: {
    url: "/meeting/waiting-room",
  },
  time_zone_list_api: {
    url: "/meeting/timezones",
  },
  meeting_video_browse: {
    url: "/v1/about/video-browse",
  },
  reschedule_meet_self: {
    url: "/meeting/reschedule-meeting",
  },
  homepage_wellness: {
    url: "/master/get-wellness-hub-sections",
  },
  new_featured_provider: {
    url: "/about/featured-providers",
  },
  stream_generate_token: {
    url: "/stream/generate-token",
  },
  meeting_update_status: {
    url: "/meeting/update-status",
  },
  meeting_notify_to_host: {
    url: "/meeting/notify-to-host",
  },
  get_about_list: {
    url: "/v1/about/list",
  },
  meeting_get_meet_lists_google_sync: {
    url: "/meeting/get-meet-lists-google-sync",
  },
  referral_summary: {
    url: "/referrals/summary",
  },
  referral_performance: {
    url: "/referrals/performance",
  },
  referral_channels: {
    url: "/referrals/channels",
  },
  referral_history: {
    url: "/referrals/history",
  },
  credit_history: {
    url: "/referrals/credit-history",
  },
  recent_activity: {
    url: "/referrals/recent-activity",
  },
  referral_recent_activity_count: {
    url: "/referrals/recent-activity-count",
  },
  get_wellness_all_list: {
    url: "/v1/about/wellness-categories-list",
  },
  get_general_setting_ist: {
    url: "super-admin/settings/wallet-fee-settings",
  },
  get_revenue_settings: {
    url: "revenue-settings/get",
  },
  update_revenue_settings: {
    url: "revenue-settings/update",
  },
  direct_subscribe_and_exclusive: {
    url: "revenue-settings/get",
  },
  get_category_modal: {
    url: "/master/feature-categories/by-provider-role",
  },
  get_subcategory_modal: {
    url: "/about/feature-categories/condition/sub-categories",
  },
  get_group_modal: {
    url: "/about/feature-categories/condition/groups",
  },
  get_subgroup_modal: {
    url: "/about/feature-categories/condition/sub-groups",
  },
  add_dropdown_datas: {
    url: "/about/feature-categories/condition/clinical-specialties",
  },
  search_condition_list: {
    url: "/master/feature-category/condition-type/list",
  },
  update_clinical_specialities: {
    url: "/about/update-clinical-specialities",
  },
  get_treatment_category_list: {
    url: "/master/treatment-modality/by-provider-role",
  },
  get_treatment_subcategory_modal: {
    url: "/about/treatment-modality/sub-categories",
  },
  get_treatment_group_modal: {
    url: "/about/treatment-modality/groups",
  },
  get_treatment_subgroup_modal: {
    url: "/about/treatment-modality/sub-groups",
  },
  add_treatment_modalities: {
    url: "/about/treatment-modality/treatment-modalities",
  },
  search_treatment_modality_list: {
    url: "/master/treatment-modality/listnew",
  },
  updateTreatmentModalityDataApi: {
    url: "/about/treatment-modality/update",
  },
  get_blog_filter_category_dropdown: {
    url: "/written-content/public/blog-category-filter",
  },
  get_blog_list_all_filters: {
    url: "/written-content/public/blog-list",
  },
};
